<template>
  <f7-page name="profile">
    <f7-navbar title="Профиль" back-link-force back-link-url="/" back-link></f7-navbar>

    <f7-list no-hairlines-md id="profileData">
      <f7-list-input label="Ф.И.О." type="text" placeholder="Ваше Ф.И.О." name="name" v-model="$root.user.name"
        :value="$root.user.name" @input="$root.user.name = $event.target.value"
        error-message="Укажите, как к вам можно обращаться" @focus="errorUserName = false"
        :error-message-force="errorUserName"></f7-list-input>
      <f7-list-input label="Телефон" type="tel" placeholder="+7 912 987-65-32" disabled name="phone"
        :value="$root.phoneFormat($root.user.phone)" @input="$root.user.phone = $event.target.value"
        error-message="Укажите номер телефона" @focus="errorUserPhone = false" :error-message-force="errorUserPhone"
        :readonly="!isStart"></f7-list-input>
      <f7-list-input label="E-mail" type="email" placeholder="E-mail" name="email" :value="$root.user.email"
        @input="$root.user.email = $event.target.value" error-message="Укажите e-mail" @focus="errorUserEmail = false"
        :error-message-force="errorUserEmail"></f7-list-input>
      <!--template v-if="!isStart">
        <f7-list-item title="Получать уведомления">
          <f7-toggle slot="after"></f7-toggle>
        </f7-list-item>
      </template-->
    </f7-list>

    <template v-if="!isStart">
      <f7-block-title>Гараж</f7-block-title>
      <f7-list>
        <f7-list-item v-for="(car, index) in $root.garage.data" :key="index" :title="car.attributes.carBrand" link="#"
          @click="$root.createPopup(car.id)">
          <f7-icon slot="media" f7="car_fill"></f7-icon>
        </f7-list-item>

        <f7-list-item title="Добавить автомобиль" @click="$root.createPopup" link="#">
          <f7-icon slot="media" f7="plus_circle"></f7-icon>
        </f7-list-item>
      </f7-list>
    </template>
    <f7-block v-if="isStart">
      <f7-row tag="p">
        <f7-button round class="col" @click="checkForm" fill>Далее</f7-button>
      </f7-row>
    </f7-block>
  </f7-page>
</template>

<script>
export default {
  data() {
    return {
      isStart: this.$f7route.context.start,
      errorUserName: false,
      errorUserEmail: false,
      errorUserPhone: false
    };
  },
  watch: {
    "$root.user.name": {
      handler: "updateStorage"
    },
    "$root.user.email": {
      handler: "validEmail"
    },
    "$root.user.phone": {
      handler: "validPhone"
    }
  },
  methods: {
    checkForm() {
      var errors = [];
      var formData = this.$f7.form.convertToData("#profileData");

      if (formData.name == "") {
        this.errorUserName = true;
        errors.push("errorUserName");
      }

      if (!this.validPhone(formData.phone)) {
        this.errorUserPhone = true;
        errors.push("errorUserPhone");
      }

      if (!this.validEmail(formData.email)) {
        this.errorUserEmail = true;
        errors.push("errorUserEmail");
      }

      if (!errors.length) {
        console.log("На главную.");
        window.location.replace("/");
        if (this.isStart) {
          localStorage.setItem("goto", '/price/');
        }

        // this.$f7router.back("/price/", { force: true });
        // //  this.$f7.views.main.router.navigate("/price/");
        // //  this.$f7.views.main.router.load({ url: "/price" })
        // // this.$f7router.navigate('/price/')
        // this.$root.cars("", "GET", "cars", ["garage", "popup"]);
        // // this.$root.popupOpened = true;
        // // this.$f7.views.main.router.navigate("/price/");
      }
    },
    validEmail() {
      var formData = this.$f7.form.convertToData("#profileData");
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(formData.email).toLowerCase())) {
        this.updateStorage();
        return true;
      }
    },
    validPhone() {
      var formData = this.$f7.form.convertToData("#profileData");
      var re = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
      if (re.test(formData.phone)) {
        this.updateStorage();
        return true;
      }
    },
    updateStorage() {
      var formData = this.$f7.form.convertToData("#profileData");
      // console.log(formData);
      this.writeStorage(formData);
      var toast = this.$f7.toast.create({
        text: `Изменения сохранены.`,
        closeTimeout: 5000
      });
      toast.open();
    },
    writeStorage(formData) {
      // var user = JSON.parse(localStorage.getItem("user"))
      //   ? JSON.parse(localStorage.getItem("user"))
      //   : [];
      // user.push(formData);
      localStorage.setItem("user", JSON.stringify(formData));
      this.$root.user = formData;
    }
  },
  created() {
    this.$root.cars("", "GET", "cars", ["garage"]);
  }
};
</script>